<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0"> آرشیو نام های مشتری مشتری '{{Customer_Inner.name}}' </h5>
     <br/>

     <button  (click)="OnSet_Back_TitleView()"  type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>



      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام قدیم</th>
              <th>نام جدید</th>
              <th>ثبت کننده</th>
              <th>تاریخ ثبت</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Title
            | paginate
                    : {
                        id: 'DataList_Title',
                        itemsPerPage: 100,
                        currentPage: page,
                        totalItems: (DataList_Title).length
                      }
            " [ngClass]="{'Special': item.special}">
             <td>{{DataList_Title.indexOf(item)+1}}</td>
              <td>{{item.oldTitle}}</td>
              <td>{{item.newTitle}}</td>
              <td>{{item.username}}</td>
              <td>{{item.subdate}}</td>
            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_Title"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>
